(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initCartFeedback = () => {
    const status = document.getElementById('MoonroadStatus');
    const initialCount = document.querySelector('.header-cart__count');
    if (!status || !initialCount || document.documentElement.dataset.mrCartFeedbackReady === 'true') return;

    const readCount = () => Number.parseInt(document.querySelector('.header-cart__count')?.textContent, 10) || 0;
    let previousCount = readCount();
    const observer = new MutationObserver(() => {
      const nextCount = readCount();
      if (nextCount > previousCount) {
        previousCount = nextCount;
        const counts = document.querySelectorAll('.header-cart__count');
        counts.forEach((count) => count.classList.remove('mr-cart-pulse'));
        status.textContent = '';
        requestAnimationFrame(() => {
          counts.forEach((count) => count.classList.add('mr-cart-pulse'));
          status.textContent = status.dataset.cartAdded || '';
        });
        window.setTimeout(() => counts.forEach((count) => count.classList.remove('mr-cart-pulse')), 700);
        return;
      }
      previousCount = nextCount;
    });

    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    document.documentElement.dataset.mrCartFeedbackReady = 'true';
  };

  const initMobileBuybar = (scope = document) => {
    const productSection = scope.querySelector('[data-section-type="product"]') || document.querySelector('[data-section-type="product"]');
    if (!productSection || productSection.dataset.mrBuybarReady === 'true') return;

    const originalButton = productSection.querySelector('[data-add-to-cart]');
    const price = productSection.querySelector('[data-product-detail-price]');
    const variantPanel = productSection.querySelector('.product-detail__options');
    const status = document.getElementById('MoonroadStatus');
    if (!originalButton || !price || !status) return;

    const buybar = document.createElement('div');
    const buybarPrice = document.createElement('span');
    const buybarButton = document.createElement('button');

    buybar.className = 'mr-mobile-buybar';
    buybar.setAttribute('role', 'region');
    buybar.setAttribute('aria-label', status.dataset.buybarLabel || 'Purchase');
    buybarPrice.className = 'mr-mobile-buybar__price';
    buybarButton.className = 'mr-mobile-buybar__button';
    buybarButton.type = 'button';
    buybar.append(buybarPrice, buybarButton);
    document.body.append(buybar);

    const sync = () => {
      const originalText = originalButton.textContent.trim();
      buybarPrice.textContent = price.textContent.trim();
      buybarButton.textContent = variantPanel ? status.dataset.selectOptions : originalText;
      buybarButton.disabled = originalButton.disabled;
      buybarButton.setAttribute('aria-disabled', originalButton.disabled ? 'true' : 'false');
    };

    buybarButton.addEventListener('click', () => {
      if (variantPanel) {
        variantPanel.scrollIntoView({
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
          block: 'center'
        });
        const firstControl = variantPanel.querySelector('select, input, button');
        if (firstControl) window.setTimeout(() => firstControl.focus(), reducedMotion.matches ? 0 : 280);
        return;
      }
      originalButton.click();
    });

    const syncObserver = new MutationObserver(sync);
    syncObserver.observe(originalButton, { attributes: true, childList: true, subtree: true });
    syncObserver.observe(price, { childList: true, characterData: true, subtree: true });

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        document.body.classList.toggle('mr-buybar-visible', !entry.isIntersecting);
      }, { threshold: 0.25 });
      visibilityObserver.observe(originalButton);
    }

    document.body.classList.add('mr-buybar-ready');
    productSection.dataset.mrBuybarReady = 'true';
    sync();
  };

  const init = (scope = document) => {
    document.documentElement.dataset.moonroadReady = 'true';
    initCartFeedback();
    initMobileBuybar(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
